import Modal from "components/layout/modal";
import { FunctionComponent } from "react";
import ApproveModalForm from "./approve-modal-form";
import { LocaleString } from "models/locale";

interface ApproveModalProps {
  onSubmit: (
    timestamp: Date,
    send_email: boolean,
    subject: LocaleString,
    message: LocaleString,
  ) => Promise<void>;
  onClose: () => Promise<void>;
}

const ApproveModal: FunctionComponent<ApproveModalProps> = ({
  onSubmit,
  onClose,
}) => {
  const handleSubmit = async (
    approved_at: Date,
    send_email: boolean,
    subject: LocaleString,
    message: LocaleString,
  ) => {
    await onSubmit(approved_at, send_email, subject, message);
    await onClose();
  };

  return (
    <Modal title="Tarkasta ilmoitus">
      <ApproveModalForm onSubmit={handleSubmit} onClose={onClose} />
    </Modal>
  );
};

export default ApproveModal;
